// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__14pRd","bigColWidth":"Table_bigColWidth__yZ9HF","biggerColWidth":"Table_biggerColWidth__1zh7C","row":"Table_row__OtHPN","col":"Table_col__LkI8j"};